import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { OperatorEntity } from "app/interfaces";
import { StatusEntity } from "app/interfaces/status-response.entity";
import { environment } from "environments/environment";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class WatcherService {
  private _baseUrl: string = `${environment.baseUrlWs}${environment.wsVerison}/employer`;

  constructor(private http: HttpClient) {}

  public retrieveOperators(): Observable<OperatorEntity[]> {
    const url: string = `${this._baseUrl}/operators`;
    return this.http.get(url) as Observable<OperatorEntity[]>;
  }

  public deleteWatcher(jobOfferId: number): Observable<StatusEntity> {
    const url: string = `${this._baseUrl}/jobs/${jobOfferId}/watchers/`;
    return this.http.delete(url) as Observable<StatusEntity>;
  }

  public setWatcher(
    jobOfferId: number,
    operatorid: number
  ): Observable<StatusEntity> {
    const url: string = `${this._baseUrl}/jobs/${jobOfferId}/watchers/${operatorid}`;
    return this.http.post(url, null) as Observable<StatusEntity>;
  }
}
